import clsx from 'clsx'

const toneClasses = {
  primary: 'text-primary',
  success: 'text-success',
  danger: 'text-danger',
  info: 'text-info',
  muted: 'text-muted',
  default: 'text-text'
}

const sizeClasses = {
  primary: 'text-[clamp(1.9rem,5vw,2.75rem)]',
  secondary: 'text-[clamp(1.4rem,4vw,2rem)]',
  tertiary: 'text-[clamp(1rem,3vw,1.5rem)]'
}

const StatRow = ({
  label,
  value,
  tone = 'default',
  size = 'secondary',
  align = 'right',
  className,
  valueClassName,
  labelClassName
}) => {
  const alignClass =
    align === 'center' ? 'text-center' : align === 'left' ? 'text-left' : 'text-right'

  return (
    <div className={clsx('w-full min-w-0', alignClass, className)}>
      <div
        className={clsx(
          'w-full min-w-0 font-semibold tabular-nums',
          sizeClasses[size] || sizeClasses.secondary,
          !valueClassName && (toneClasses[tone] || toneClasses.default),
          valueClassName
        )}
      >
        {value}
      </div>
      {label && (
        <div
          className={clsx(
            'mt-1 w-full min-w-0 text-label sm:text-sm font-medium text-muted',
            labelClassName
          )}
        >
          {label}
        </div>
      )}
    </div>
  )
}

export default StatRow
